import * as angular from "angular";
import {ItinerariesTasksSettings} from "../angular/models/itineraries-tasks-settings.model";

const events = {
  updatedTasks: 'updated-tasks',
  recalcRequirementProgress: 'recalc-requirement-progress',
  requirementTypeSelect: 'requirementTypeSelect'
};

const requirementApproveState = {
  Approved: 'Approved',
  Rejected: 'Rejected'
};

const types = [
  'Driver',
  'ServiceAgent',
  'Robot'
];

const skills = [
  'Delivery',
  'Merchandise',
  'Order'
];

const statuses = [
  'OnDuty',
  'OnDutyOnBreak',
  'OffDuty',
];

const skillsByType = {
  Driver: ['Delivery'],
  ServiceAgent: ['Merchandise', 'Order'],
  Robot: ['AutonomousAgent'],
  All: ['Delivery', 'Merchandise', 'Order', 'AutonomousAgent']
};

const typeBySkills = {
  Delivery: 'Delivery',
  Merchandise: 'Operation',
  Order: 'Operation',
  Robot: 'AutonomousAgent'
};

const permissionsByType = {
  Driver: {
    list: 'drivers.list',
    create: 'drivers.create',
    update: 'drivers.update',
    delete: 'drivers.delete'
  },
  ServiceAgent: {
    list: 'operationalservice.serviceAgent.list',
    create: 'operationalservice.serviceAgent.create',
    update: 'operationalservice.serviceAgent.update',
    delete: 'operationalservice.serviceAgent.delete'
  },
  Robot: {
    list: 'robotAgent.list',
    create: 'robotAgent.create',
    update: 'robotAgent.update',
    delete: 'robotAgent.delete'
  }
};

const importSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2Fimport-agents.xlsx?alt=media&token=29e8d35c-ec25-4670-8c4b-3aaa17764903';

const agentsTableColumnsMap = {
  externalId: {enabled: true, order: 0, permission: undefined},
  type: {enabled: true, order: 1, permission: undefined},
  mode: {enabled: true, order: 2, permission: undefined},
  vendor: {enabled: true, order: 3, permission: undefined},
  employment: {enabled: true, order: 4, permission: undefined},
  branches: {enabled: true, order: 5, permission: undefined},
  mobile: {enabled: true, order: 6, permission: undefined},
  email: {enabled: true, order: 7, permission: undefined},
  vehicle: {enabled: true, order: 8, permission: undefined},
  deviceType: {enabled: true, order: 9, permission: undefined},
  gpsStatus: {enabled: true, order: 10, permission: undefined},
  gpsPermission: {enabled: true, order: 11, permission: undefined},
  sessionRecording: {enabled: false, order: 12, permission: undefined},
  licensePlate: {enabled: true, order: 13, permission: undefined},
  tasks: {enabled: true, order: 14, permission: undefined},
  status: {enabled: true, order: 15, permission: undefined},
  progress: {enabled: true, order: 16, permission: undefined},
  zoneId: {enabled: true, order: 17, permission: undefined},
  team: {enabled: false, order: 18, permission: undefined},
  createdAt: {enabled: true, order: 19, permission: undefined},
  configurationProfile: {enabled: true, order: 20, permission: undefined}
}

const agentsTableColumnsMapLean = {
  type: {enabled: true, order: 1, permission: undefined},
  mode: {enabled: true, order: 2, permission: undefined},
  vendor: {enabled: true, order: 3, permission: undefined},
  employment: {enabled: true, order: 4, permission: undefined},
  branches: {enabled: true, order: 5, permission: undefined},
  mobile: {enabled: true, order: 6, permission: undefined},
  vehicle: {enabled: true, order: 8, permission: undefined},
  gpsStatus: {enabled: false, order: 9, permission: undefined},
  gpsPermission: {enabled: false, order: 10, permission: undefined},
  licensePlate: {enabled: true, order: 11, permission: undefined},
  status: {enabled: true, order: 13, permission: undefined},
  progress: {enabled: true, order: 14, permission: undefined},
  createdAt: {enabled: true, order: 15, permission: undefined}
}

const itinerariesTasksTableSections: ItinerariesTasksSettings = {
  sections: {
    timeAndLocation: true,
    capacity: true,
    tags: true,
    proNumber: true,
  }
}


angular
  .module('bringoz.admin.agents')
  .constant('agentConstants', {
    events: events,
    requirementApproveState: requirementApproveState,
    types: types,
    skills: skills,
    statuses: statuses,
    skillsByType: skillsByType,
    typeBySkills: typeBySkills,
    permissionsByType: permissionsByType,
    importSampleFileLink: importSampleFileLink,
    agentsTableColumnsMap: agentsTableColumnsMap,
    agentsTableColumnsMapLean: agentsTableColumnsMapLean,
    itinerariesTasksTableSections: itinerariesTasksTableSections
  });

